import request from '../index';

/**
 * 获取邀请列表（后台）
 */
export function getInvitationList(params) {
  return request({
    url: '/invitations/admin/list',
    method: 'get',
    params
  });
}

/**
 * 获取待审核邀请列表（后台）
 */
export function getPendingReviewList(params) {
  return request({
    url: '/invitations/admin/pending-review',
    method: 'get',
    params
  });
}

/**
 * 获取邀请详情
 */
export function getInvitationDetail(id) {
  return request({
    url: `/invitations/admin/${id}`,
    method: 'get'
  });
}

/**
 * 获取邀请统计
 */
export function getInvitationStats() {
  return request({
    url: '/invitations/admin/stats',
    method: 'get'
  });
}

/**
 * 处理过期邀请
 */
export function handleExpiredInvitations() {
  return request({
    url: '/invitations/admin/handle-expired',
    method: 'post'
  });
}

/**
 * 审核通过
 */
export function approveInvitation(id, remark) {
  return request({
    url: `/invitations/admin/${id}/approve`,
    method: 'post',
    data: { remark }
  });
}

/**
 * 审核拒绝
 */
export function rejectReview(id, remark) {
  return request({
    url: `/invitations/admin/${id}/reject`,
    method: 'post',
    data: { remark }
  });
}
